/* Filtro para formatação de CNAE - Classificação Nacional de Atividades Econômicas */
angular.module("avlib").filter('avCnae', function () {
	return function(cnae){
		if (cnae != null){
			while (cnae.length < 7){
				cnae = "0"+cnae;
			}
			return cnae.substr(0,4)+"-"+cnae.substr(4,1)+"/"+cnae.substr(5,2);
		}
		return null;
	};
});
